import React, { PureComponent } from 'react';
import { Container, Row } from 'reactstrap';
import SbCampaignsGrid from './components/SbCampaignsGrid';
import PageHeader from '../../../../shared/components/PageHeader';

class SbCampaignsPage extends PureComponent {
  render() {
    return (
      <Container>
        <Row>
          <PageHeader title="Amazon Sponsored Brand Campaigns" subhead="Selected Account Data" />
        </Row>
        <Row>
          <SbCampaignsGrid />
        </Row>
      </Container>
    );
  }
}

export default SbCampaignsPage;
